import {announce} from '@github-ui/aria-live'
import {useEffect, useRef} from 'react'

interface EnvironmentFreshnessOptions {
  hasEnvironment: boolean
  loading: boolean
  error: boolean
}

export function getEnvironmentFreshness({
  hasEnvironment,
  loading,
  error,
}: EnvironmentFreshnessOptions): string | undefined {
  if (error) return hasEnvironment ? 'Last known; refresh failed' : 'Status unavailable'
  if (loading) return 'Loading status'
  return undefined
}

export function useAnnounceEnvironmentDetails(detailsVisible: boolean, announcement: string | undefined) {
  const previousAnnouncementRef = useRef<string | undefined>(undefined)

  useEffect(() => {
    if (!detailsVisible) {
      previousAnnouncementRef.current = undefined
      return
    }
    if (previousAnnouncementRef.current === undefined) {
      previousAnnouncementRef.current = announcement
      return
    }
    if (announcement && announcement !== previousAnnouncementRef.current) announce(announcement)
    previousAnnouncementRef.current = announcement
  }, [announcement, detailsVisible])
}
